var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showEcharts)?_c('div',{staticClass:"app-container"},[_c('div',{ref:"echartsRef1",staticStyle:{"width":"100%","height":"500px"}}),_c('div',{ref:"echartsRef2",staticStyle:{"width":"100%","height":"300px","padding-top":"10px"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }